import { casinoNavigation } from './products/casino/casino';
import { liveCasinoNavigation } from './products/live-casino/live-casino';
import { lotteriesNavigation } from './products/lotteries/lotteries';
import { scratchcardsNavigation } from './products/scratchcards/scratchcards';
import { sportsNavigation } from './products/sports/sports';
import type { NavigationRegistry } from './types';

/**
 * Simple registry, to get product navigation configuration from a single source
 * Support all product verticals: lotteries, sports, casino, scratchcards, live-casino
 */
const navigationRegistry = {
  lotteries: lotteriesNavigation,
  sports: sportsNavigation,
  casino: casinoNavigation,
  scratchcards: scratchcardsNavigation,
  'live-casino': liveCasinoNavigation,
} satisfies NavigationRegistry;

export { navigationRegistry };
